import { IGetJobPostDetailResult } from '../types';
import { JobPostAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';

export const getJobPostDetail = async (id: string): Promise<IGetJobPostDetailResult> => {
  const response = await PermanentJobsApi.getJobPostDetail(id);

  return JobPostAdapters.toGetJobPostDetailResult(response);
};
